declare namespace $ {

	type $mol_string__hint_our_app_dev_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__hint_our_app_dev_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__hint_our_app_dev_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_button_major__title_our_app_dev_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_form__form_fields_our_app_dev_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['form_fields'] >
	>
	type $mol_form__buttons_our_app_dev_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['buttons'] >
	>
	type $mol_page__title_our_app_dev_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_our_app_dev_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_text__text_our_app_dev_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_our_app_dev_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_list__rows_our_app_dev_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_string__hint_our_app_dev_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__hint_our_app_dev_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__hint_our_app_dev_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__hint_our_app_dev_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__hint_our_app_dev_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__hint_our_app_dev_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__hint_our_app_dev_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__hint_our_app_dev_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_button_major__title_our_app_dev_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_minor__title_our_app_dev_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_form__form_fields_our_app_dev_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['form_fields'] >
	>
	type $mol_form__buttons_our_app_dev_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['buttons'] >
	>
	type $mol_page__title_our_app_dev_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_our_app_dev_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_text__text_our_app_dev_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_major__title_our_app_dev_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_page__title_our_app_dev_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_our_app_dev_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	export class $our_app_dev extends $mol_book2_catalog {
		Name_control( ): $mol_string
		Country_control( ): $mol_string
		Telegram_control( ): $mol_string
		Update_profile( ): $mol_button_major
		Profile_form( ): $mol_form
		Profile_page( ): $mol_page
		Game_1( ): $mol_text
		Game_2( ): $mol_text
		Game_list( ): $mol_list
		Game_name_control( ): $mol_string
		Game_genre_control( ): $mol_string
		Game_description_control( ): $mol_string
		Game_social_control( ): $mol_string
		Game_youtube_control( ): $mol_string
		Game_steam_control( ): $mol_string
		Game_vk_control( ): $mol_string
		Game_date_control( ): $mol_string
		Game_add( ): $mol_button_major
		Game_show( ): $mol_button_minor
		Game_form( ): $mol_form
		Games( ): $mol_page
		Show_text( ): $mol_text
		Update_show( ): $mol_button_major
		Show( ): $mol_page
		menu_title( ): string
		param( ): string
		spreads( ): ({ 
			'profile': ReturnType< $our_app_dev['Profile_page'] >,
			'games': ReturnType< $our_app_dev['Games'] >,
			'show': ReturnType< $our_app_dev['Show'] >,
		}) 
	}
	
}

//# sourceMappingURL=dev.view.tree.d.ts.map